import {checkAddress} from '@polkadot/util-crypto';
import axios from 'axios';


async function checkCddVerification(address) {

    const did = await getDIDFromAddress(address)
    return did && (await getIdentityStatus(did)) === 'CddVerified';

}

async function getDIDFromAddress(address) {
    try {
        const response = await axios.post('https://mainnet-rpc.polymesh.network/http', {
            jsonrpc: "2.0",
            id: 1,
            method: "identity_getKeyIdentityData",
            params: [address]
        });

        if (response.data.result && response.data.result.identity) {
            return response.data.result.identity;
        }
        return false;
    } catch (error) {
        return false;
    }
}

async function getIdentityStatus(did) {
    try {
        const response = await axios.post('https://mainnet-rpc.polymesh.network/http',
            {
                jsonrpc: "2.0",
                id: 1,
                method: "identity_getDidStatus",
                params: [[did]]
            });
        return response.data.result[0];
    } catch (error) {
        return false;
    }
}


export default {
    async isValidAddress(address, currency, opts = {}) {

        const prefix = currency.prefix;

        if (Array.isArray(prefix)) {
            let isValid = false;
            for (let i = 0; i < prefix.length; i++) {
                if (this.checkPolymeshAddress(address, prefix[i])) {
                    return  await checkCddVerification(address);
                }
            }
            if (!isValid) {
                return false;
            }
        }

        try {
            if(this.checkPolymeshAddress(address, prefix)) {
                return await checkCddVerification(address);
            }
        } catch (error) {
            return false;
        }

    },
    checkPolymeshAddress(address, prefix) {
        const [result, message] = checkAddress(address, prefix);
        return result;
    },
};

